// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-menus-social-menu----social-menu-module---list---O769F","item":"src-components-menus-social-menu----social-menu-module---item---2MBy7","link":"src-components-menus-social-menu----social-menu-module---link---2SRyq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/social-menu/social-menu.module.css
// module id = 89
// module chunks = 35783957827783 51793018361034 114276838955818